import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import apiClient from "@/api/apiClient";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Lưu token vào localStorage
 */
export const setToken = (token: string, refreshToken?: string) => {
  if (token) {
    localStorage.setItem('token', token);
    apiClient.setAuthToken(token);
  }
  
  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  }
};

/**
 * Lấy token từ localStorage
 */
export const getToken = (): string | null => {
  const token = localStorage.getItem('token');
  return token;
};

/**
 * Lấy refresh token từ localStorage
 */
export const getRefreshToken = (): string | null => {
  const refreshToken = localStorage.getItem('refreshToken');
  return refreshToken;
};

/**
 * Xóa token khỏi localStorage
 */
export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  apiClient.clearAuthToken();
};

/**
 * Kiểm tra xem người dùng đã đăng nhập hay chưa
 */
export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('user') && !!localStorage.getItem('token');
};

/**
 * Khởi tạo ApiClient với token nếu có
 */
export const initializeApiClient = () => {
  const token = getToken();
  if (token) {
    apiClient.setAuthToken(token);
  }
};

/**
 * Lưu thông tin đăng nhập
 */
export const saveCredentials = (username: string, password: string, remember: boolean) => {
  if (remember) {
    localStorage.setItem('rememberedUsername', username);
    localStorage.setItem('rememberedPassword', btoa(password)); // Simple encoding, not secure
    localStorage.setItem('rememberMe', 'true');
  } else {
    removeCredentials();
  }
};

/**
 * Xóa thông tin đăng nhập đã lưu
 */
export const removeCredentials = () => {
  localStorage.removeItem('rememberedUsername');
  localStorage.removeItem('rememberedPassword');
  localStorage.removeItem('rememberMe');
};

/**
 * Kiểm tra xem có thông tin đăng nhập được lưu không
 */
export const hasRememberedCredentials = (): boolean => {
  return localStorage.getItem('rememberMe') === 'true';
};

/**
 * Định dạng số tiền thành định dạng tiền tệ VND
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

/**
 * Định dạng ngày tháng
 */
export const formatDate = (date: Date | string | number): string => {
  const d = new Date(date);
  return new Intl.DateTimeFormat('vi-VN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(d);
};

/**
 * Định dạng ngày tháng ngắn gọn
 */
export const formatDateShort = (date: Date | string | number): string => {
  const d = new Date(date);
  return new Intl.DateTimeFormat('vi-VN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(d);
};
